import { z } from "zod";
import { isSupportedTimeZone } from "./calendar-time.js";
import { scheduledSessionDaysOfMonthSchema, scheduledSessionDaysOfWeekSchema, scheduledSessionNthWeekdaysSchema, } from "./scheduled-sessions.js";
const idSchema = z.string().trim().min(1).max(256);
const localTimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/u);
const timeZoneSchema = z.string().trim().min(1).max(100)
    .refine(isSupportedTimeZone, "timeZone must be a valid IANA timezone");
/**
 * When a draft workflow runs unattended, as its owner, and the channel its result
 * is posted to. Recurrence follows scheduled sessions: every day, or one of
 * weekdays, days of the month or nth weekdays, at a local time.
 */
export const setWorkflowScheduleRequestSchema = z.object({
    channelId: idSchema,
    localTime: localTimeSchema,
    timeZone: timeZoneSchema,
    daysOfWeek: scheduledSessionDaysOfWeekSchema.nullable().default(null),
    daysOfMonth: scheduledSessionDaysOfMonthSchema.nullable().default(null),
    nthWeekdays: scheduledSessionNthWeekdaysSchema.nullable().default(null),
    enabled: z.boolean().default(true),
}).strict().refine((value) => [value.daysOfWeek, value.daysOfMonth, value.nthWeekdays].filter((entry) => entry !== null).length <= 1, { message: "Choose only one of daysOfWeek, daysOfMonth, or nthWeekdays." });
export const workflowScheduleSchema = z.object({
    workflowId: idSchema,
    channelId: idSchema,
    localTime: localTimeSchema,
    timeZone: z.string(),
    daysOfWeek: scheduledSessionDaysOfWeekSchema.nullable(),
    daysOfMonth: scheduledSessionDaysOfMonthSchema.nullable(),
    nthWeekdays: scheduledSessionNthWeekdaysSchema.nullable(),
    enabled: z.boolean(),
    /** Null while the schedule is off. */
    nextRunAt: z.number().int().nullable(),
    lastRunAt: z.number().int().nullable(),
    lastRunId: idSchema.nullable(),
    /** Why the last due run could not start; a failed run reports on the run itself. */
    lastError: z.string().nullable(),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
}).strict();
export const workflowScheduleResponseSchema = z.object({
    schedule: workflowScheduleSchema.nullable(),
}).strict();
